import { TabChangeRequestService } from './../../../services/tab-switch.service';
import { ComponentPortal } from '@angular/cdk/portal';
import {
	Component,
	Inject,
	OnChanges,
	OnInit,
	SimpleChanges,
} from '@angular/core';
import {
	MatDialog,
	MatDialogRef,
	MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { SharePreviewComponent } from '../share-preview/share-preview.component';
import { EmbedComponent } from './embed/embed.component';
import { PaymentRequestComponent } from './payment-request/payment-request.component';
import { ShareFundraiserPageComponent } from './share-fundraiser-page/share-fundraiser-page.component';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgClass, NgIf } from '@angular/common';

/** *import { EmbedComponent } from './components/embed/embed.component'; */
/** *import { PreviewComponent } from './components/preview/preview.component'; */

@Component({
    selector: 'app-share-dialog',
    templateUrl: './share-dialog.component.html',
    styleUrls: ['./share-dialog.component.scss'],
    standalone: true,
    imports: [NgClass, ExtendedModule, FlexModule, MatButtonModule, MatIconModule, MatFormFieldModule, MatSelectModule, MatOptionModule, NgIf, ShareFundraiserPageComponent, PaymentRequestComponent, EmbedComponent, SharePreviewComponent]
})
export class ShareDialogComponent implements OnInit {
	// Variables for embedding components (commented out)
	/** *embedPortal: ComponentPortal<EmbedComponent>; */
	/** *embedPreview: ComponentPortal<PreviewComponent>; */

	tabIndex: number | any;

	embedOption!: number;
	fundraiserLabel = $localize`:@@share_dialog_fundraiserPage_label:Fundraiser Page`;
	donationLabel = $localize`:@@share_dialog_donationPage_label:Donation Page`;
	paymentRequestLabel = $localize`:@@share_dialog_paymentRequestPage_label:Payment Request`;
	ownWebsiteLabel = $localize`:@@share_dialog_ownWebsite_label:On own website`;
	selectedPanel: string = 'fundraiser';
	selectedName: string = this.fundraiserLabel;
	slug: any;
	profileResponse: any;

	constructor(
		public dialogRef: MatDialogRef<ShareDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public changerequest: TabChangeRequestService
	) {
		// Initialize embedding components (commented out)
		/** *this.embedPortal = new ComponentPortal(EmbedComponent); */
		/** *this.embedPreview = new ComponentPortal(PreviewComponent); */
	}

	ngOnInit(): void {
		// Subscribe to changes in the custom text from the TabChangeRequestService
		this.changerequest.currentCustomText.subscribe((data) => {
			if (data !== '') {
				this.selectedPanel = data;
				this.selectPanel(data);
			}
		});

		// Initialize slug and profileResponse from the injected data
		this.slug = this.data?.fundraiser?.slug;
		this.profileResponse = this.data?.profileResponse?.profile;
	}

	// Handle tab change event
	tabChange(event: any) {}

	// Close the dialog
	onCloseClick() {
		this.dialogRef.close();
	}

	// Select the panel based on the provided panel name
	selectPanel(panel: string) {
		try {
			this.selectedPanel = panel;

			switch (panel) {
				case 'fundraiser':
					this.selectedName = this.fundraiserLabel;
					break;
				case 'donate':
					this.selectedName = this.donationLabel;
					break;
				case 'paymentRequest':
					this.selectedName = this.paymentRequestLabel;
					break;
				case 'ownWebsite':
					this.selectedName = this.ownWebsiteLabel;
					break;
				default:
					// Handle unexpected panel values
					console.warn(`Unexpected panel value: ${panel}`);
					this.selectedName = this.fundraiserLabel; // Default to fundraiser label
					break;
			}
		} catch (error) {
			console.error('Error selecting panel:', error);
			// Set default values in case of an error
			this.selectedPanel = 'fundraiser';
			this.selectedName = this.fundraiserLabel;
		}
	}
}
